/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Guard_TitleInputs */

const en_mk_sec_pg_guard_title = /** @type {(inputs: Mk_Sec_Pg_Guard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six limits that make an agent safe to assign`)
};

const id_mk_sec_pg_guard_title = /** @type {(inputs: Mk_Sec_Pg_Guard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam batas yang membuat agen aman ditugaskan`)
};

/**
* | output |
* | --- |
* | "Six limits that make an agent safe to assign" |
*
* @param {Mk_Sec_Pg_Guard_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_guard_title = /** @type {((inputs?: Mk_Sec_Pg_Guard_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Guard_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_guard_title(inputs)
	return en_mk_sec_pg_guard_title(inputs)
});